
import { useState } from 'react';
import '../App.scss';
import { Container, Row } from 'react-bootstrap';

function AcceptableUsePolicy() {

  return (
    <main>
      <Container className="py-6 py-sm-8">
        <h1 className="pb-4">Our Acceptable Use Policy</h1>
        <Row className="align-items-center mb-6">
          <iframe
          title="PDF Viewer"
          width="100%"
          height="1000px"
          src="/AcceptableUsePolicy.pdf"
      ></iframe>
        </Row>
      </Container>

    </main>
  );
}

export default AcceptableUsePolicy;